var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "Model",
    {
      attrs: {
        form: _vm.form,
        "init-form": _vm.initForm,
        "is-show": _vm.isShowModel,
        fullscreen: "",
        "custom-title": _vm.dialogTitle,
        "save-item": _vm.saveItem,
        "can-submit": _vm.canSubmit,
        "before-cancel": _vm.onBeforeCancel,
      },
      on: {
        "update:isShow": function ($event) {
          _vm.isShowModel = $event
        },
        "update:is-show": function ($event) {
          _vm.isShowModel = $event
        },
      },
    },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "loading",
              rawName: "v-loading",
              value: !_vm.canSubmit,
              expression: "!canSubmit",
            },
          ],
        },
        [
          _c(
            "div",
            {
              directives: [
                {
                  name: "show",
                  rawName: "v-show",
                  value: !_vm.changeTime.visible,
                  expression: "!changeTime.visible",
                },
              ],
            },
            [
              _c(
                "BoxWrap",
                { attrs: { "no-title": "" } },
                [
                  _c(
                    "el-form",
                    {
                      ref: "dataForm",
                      attrs: {
                        model: _vm.form,
                        rules: _vm.rules,
                        size: "small",
                        inline: "",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          staticClass: "flexRow",
                          attrs: {
                            rules: _vm.rules.validateChoose,
                            label: _vm.$t("doubleWeekPlan.input.planRangeTime"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("RangePick", {
                            attrs: {
                              "target-form": _vm.form,
                              "key-list": [
                                "planTaskStartTime",
                                "planTaskEndTime",
                              ],
                              "plan-task-date": _vm.actDateinfo.planTaskDate,
                              "actual-plan-task-flag": _vm.actualPlanTaskFlag,
                              inline: "",
                              "picker-line": "",
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "BoxWrap",
                {
                  attrs: {
                    title: _vm.$t("doubleWeekPlan.BoxWrap.chooseStore"),
                  },
                },
                [
                  _c(
                    "el-form",
                    {
                      ref: "searchForm",
                      staticClass: "searchGroup",
                      attrs: {
                        model: _vm.searchForm,
                        size: "small",
                        inline: "",
                      },
                    },
                    [
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.table.storeName"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.searchForm.storeName },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "storeName",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.table.storeCode"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.searchForm.storeCode },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "storeCode",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.input.storeContact"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.searchForm.contactor },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "contactor",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "doubleWeekPlan.input.TTPSigningVolume"
                            ),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.searchForm.tppGySign,
                              options: _vm.optConfig.tppOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "tppGySign",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.table.PCD"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormCascader", {
                            attrs: {
                              "target-form": _vm.searchForm,
                              "key-list": [
                                "region",
                                "regionCode",
                                "city",
                                "cityCode",
                                "district",
                                "districtCode",
                              ],
                              "region-props": _vm.regionProps,
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.table.storeAddress"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormInput", {
                            attrs: { val: _vm.searchForm.storeAddress },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "storeAddress",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("doubleWeekPlan.table.retailerType"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.searchForm.retailerType,
                              options: _vm.optConfig.storeCategoryOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "retailerType",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t(
                              "doubleWeekPlan.table.rtlRtmCategory"
                            ),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.searchForm.rtlRtmCategory,
                              options: _vm.optConfig.rtmOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "rtlRtmCategory",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                      _vm._v(" "),
                      _c(
                        "el-form-item",
                        {
                          attrs: {
                            label: _vm.$t("SRStoreList.form.isBaiLian"),
                            "label-width": _vm.formLabelWidth,
                          },
                        },
                        [
                          _c("FormSelect", {
                            attrs: {
                              val: _vm.searchForm.isBaiLian,
                              options: _vm.optConfig.yesnoOptions,
                            },
                            on: {
                              "update:val": function ($event) {
                                return _vm.$set(
                                  _vm.searchForm,
                                  "isBaiLian",
                                  $event
                                )
                              },
                            },
                          }),
                        ],
                        1
                      ),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "div",
                    { attrs: { slot: "footer-right" }, slot: "footer-right" },
                    [
                      _c(
                        "el-button",
                        {
                          attrs: { size: "small", icon: "el-icon-refresh" },
                          on: { click: _vm.resetData },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.reset")))]
                      ),
                      _vm._v(" "),
                      _c(
                        "el-button",
                        {
                          staticClass: "t-search-btn",
                          attrs: { size: "small", icon: "el-icon-search" },
                          on: { click: _vm.searchData },
                        },
                        [_vm._v(_vm._s(_vm.$t("common.search")))]
                      ),
                    ],
                    1
                  ),
                ],
                1
              ),
              _vm._v(" "),
              _c(
                "BoxWrap",
                {
                  attrs: {
                    "no-title": _vm.actualPlanTaskFlag !== _vm.PT_STATUS_TASK,
                  },
                },
                [
                  _c(
                    "div",
                    { attrs: { slot: "header-right" }, slot: "header-right" },
                    [
                      _vm.actualPlanTaskFlag === _vm.PT_STATUS_TASK
                        ? _c(
                            "el-button",
                            {
                              attrs: { type: "primary" },
                              nativeOn: {
                                click: function ($event) {
                                  return _vm.onAddStore($event)
                                },
                              },
                            },
                            [
                              _vm._v(
                                _vm._s(_vm.$t("doubleWeekPlan.role.newStore"))
                              ),
                            ]
                          )
                        : _vm._e(),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm.isShowModel
                    ? _c(
                        "el-table",
                        {
                          directives: [
                            {
                              name: "loading",
                              rawName: "v-loading",
                              value: _vm.table.listLoading,
                              expression: "table.listLoading",
                            },
                          ],
                          ref: "table",
                          staticStyle: { width: "100%" },
                          attrs: {
                            data: _vm.table.list,
                            "row-key": "storeCode",
                            stripe: "",
                            border: "",
                            "highlight-current-row": "",
                            "tooltip-effect": "dark",
                          },
                          on: { "selection-change": _vm.handleStoreChecked },
                        },
                        [
                          _vm.actualPlanTaskFlag === _vm.PT_STATUS_PLAN
                            ? _c("el-table-column", {
                                attrs: { type: "selection", width: "55" },
                              })
                            : _c("el-table-column", {
                                attrs: { width: "55" },
                                scopedSlots: _vm._u(
                                  [
                                    {
                                      key: "default",
                                      fn: function (scope) {
                                        return [
                                          _c(
                                            "el-radio",
                                            {
                                              attrs: {
                                                label: scope.row.storeCode,
                                              },
                                              nativeOn: {
                                                change: function ($event) {
                                                  return _vm.getCurrentRow(
                                                    scope.row
                                                  )
                                                },
                                              },
                                              model: {
                                                value:
                                                  _vm.table.taskStoreChecked
                                                    .storeCode,
                                                callback: function ($$v) {
                                                  _vm.$set(
                                                    _vm.table.taskStoreChecked,
                                                    "storeCode",
                                                    $$v
                                                  )
                                                },
                                                expression:
                                                  "table.taskStoreChecked.storeCode",
                                              },
                                            },
                                            [_vm._v(" ")]
                                          ),
                                        ]
                                      },
                                    },
                                  ],
                                  null,
                                  false,
                                  1432404986
                                ),
                              }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "storeCode",
                              label: _vm.$t("doubleWeekPlan.table.storeCode"),
                              width: "90",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "storeName",
                              label: _vm.$t("doubleWeekPlan.table.storeName"),
                              "min-width": "80",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "storeAddress",
                              label: _vm.$t(
                                "doubleWeekPlan.table.storeAddress"
                              ),
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                          _vm._v(" "),
                          _c("el-table-column", {
                            attrs: {
                              prop: "contactor",
                              label: _vm.$t("doubleWeekPlan.table.contact"),
                              width: "100",
                              align: "left",
                              "show-overflow-tooltip": "",
                            },
                          }),
                        ],
                        1
                      )
                    : _vm._e(),
                  _vm._v(" "),
                  _c("pagination", {
                    directives: [
                      {
                        name: "show",
                        rawName: "v-show",
                        value: _vm.table.total > 0,
                        expression: "table.total>0",
                      },
                    ],
                    attrs: {
                      total: _vm.table.total,
                      page: _vm.table.currPage,
                      limit: _vm.table.limit,
                    },
                    on: {
                      "update:page": function ($event) {
                        return _vm.$set(_vm.table, "currPage", $event)
                      },
                      "update:limit": function ($event) {
                        return _vm.$set(_vm.table, "limit", $event)
                      },
                      pagination: _vm.queryList,
                    },
                  }),
                ],
                1
              ),
              _vm._v(" "),
              _vm.isTask
                ? _c(
                    "BoxWrap",
                    { attrs: { "no-title": "" } },
                    [
                      _c(
                        "el-form",
                        {
                          ref: "taskForm",
                          attrs: {
                            model: _vm.taskForm,
                            rules: _vm.rules,
                            size: "small",
                            inline: "",
                          },
                        },
                        [
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "visitPurpose1",
                                rules: _vm.rules.validateChoose,
                                label: _vm.$t("doubleWeekPlan.input.target1"),
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.taskForm.visitPurpose1,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.taskForm,
                                        "visitPurpose1",
                                        $$v
                                      )
                                    },
                                    expression: "taskForm.visitPurpose1",
                                  },
                                },
                                _vm._l(
                                  _vm.optConfig.visitPurposeOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              attrs: {
                                prop: "visitPurpose2",
                                rules: _vm.rules.validateChoose,
                                label: _vm.$t("doubleWeekPlan.input.target2"),
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c(
                                "el-select",
                                {
                                  attrs: {
                                    placeholder: _vm.$t("common.pleaseSelect"),
                                  },
                                  model: {
                                    value: _vm.taskForm.visitPurpose2,
                                    callback: function ($$v) {
                                      _vm.$set(
                                        _vm.taskForm,
                                        "visitPurpose2",
                                        $$v
                                      )
                                    },
                                    expression: "taskForm.visitPurpose2",
                                  },
                                },
                                _vm._l(
                                  _vm.optConfig.visitPurposeOptions,
                                  function (item, index) {
                                    return _c("el-option", {
                                      key: index,
                                      attrs: {
                                        label: item.name,
                                        value: item.code,
                                      },
                                    })
                                  }
                                ),
                                1
                              ),
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "el-form-item",
                            {
                              staticClass: "flexRow",
                              attrs: {
                                prop: "remark",
                                rules: _vm.rules.validateIpt,
                                label: _vm.$t("doubleWeekPlan.input.desc"),
                                "label-width": _vm.formLabelWidth,
                              },
                            },
                            [
                              _c("el-input", {
                                attrs: {
                                  placeholder: _vm.$t("common.pleaseInput"),
                                  type: "textarea",
                                  rows: 4,
                                  maxlength: 300,
                                  "show-word-limit": "",
                                  autocomplete: "off",
                                },
                                model: {
                                  value: _vm.taskForm.remark,
                                  callback: function ($$v) {
                                    _vm.$set(_vm.taskForm, "remark", $$v)
                                  },
                                  expression: "taskForm.remark",
                                },
                              }),
                            ],
                            1
                          ),
                        ],
                        1
                      ),
                    ],
                    1
                  )
                : _vm._e(),
              _vm._v(" "),
              _c("AddEditStoreModel", {
                ref: "addEditStoreModel",
                attrs: { "opt-config": _vm.optConfig },
                on: { refresh: _vm.searchData },
              }),
            ],
            1
          ),
          _vm._v(" "),
          _vm.changeTime.visible
            ? _c(
                "div",
                [
                  _c("ChangTime", {
                    ref: "changeTimeRef",
                    attrs: {
                      "target-form": _vm.changeTime,
                      "actual-plan-task-flag": _vm.actualPlanTaskFlag,
                      "plan-task-date": _vm.actDateinfo.planTaskDate,
                    },
                    on: {
                      "update:targetForm": function ($event) {
                        _vm.changeTime = $event
                      },
                      "update:target-form": function ($event) {
                        _vm.changeTime = $event
                      },
                    },
                  }),
                ],
                1
              )
            : _vm._e(),
        ]
      ),
      _vm._v(" "),
      _c("TimeConflictModel", {
        ref: "timeConflictModel",
        attrs: { "opt-config": _vm.optConfig },
      }),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }